import { COUPON_ID } from '../../constants';
import { CHECKOUT_BASKET_CLEAR } from '../checkout/types';
import {
  COUPONS_CODES_SET,
  COUPONS_INPUT_SET,
  COUPONS_REFERRAL_CHECK,
  COUPONS_REFERRAL_ERROR,
  COUPONS_REFERRAL_SET
} from './types';

/**
 * Initial state
 */
// Get any coupons from search params
let couponCodes = [];
if (typeof window !== `undefined`) {
  const queryParams = new URLSearchParams(window.location.search);
  couponCodes = queryParams.getAll(COUPON_ID);
}
const initialState = {
  couponCodes,
  couponInput: '',
  checkingReferral: false,
  referral: null
};

export default (state = initialState, action) => {
  switch (action.type) {
    case CHECKOUT_BASKET_CLEAR: {
      return {
        ...state,
        couponCodes: [],
        couponInput: '',
        referral: null,
        checkingReferral: false
      };
    }
    case COUPONS_INPUT_SET: {
      return {
        ...state,
        couponInput: action.input
      };
    }
    case COUPONS_REFERRAL_CHECK: {
      return {
        ...state,
        checkingReferral: true
      };
    }
    case COUPONS_REFERRAL_ERROR: {
      return {
        ...state,
        checkingReferral: false
      };
    }
    case COUPONS_REFERRAL_SET: {
      return {
        ...state,
        couponInput: '',
        checkingReferral: false,
        referral: action.referral
      };
    }
    case COUPONS_CODES_SET: {
      return {
        ...state,
        couponCodes: action.couponCodes
      };
    }
    default:
      return state;
  }
};
